export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0487_FC1_0785_tn.cf2b87c7.jpg";